<template>
  <article class="post">
    <a
      :href="post.acf.post_external ? post.acf.post_external : props.post.link"
      :title="props.post.post_title"
      :target="post.acf.post_external ? '_blank' : ''">
      <post-taxonomies
        v-if="false"
        :post="props.post" />
      <post-meta
        v-if="false"
        :post="props.post" />
      <div class="post-date h4">
        <time>{{ formatDate(post.date) }}</time>
      </div>
      <div
        v-if="props.post.acf.post_source"
        class="post-source"
        v-html="props.post.acf.post_source"></div>
      <p
        class="title"
        v-html="props.post.title.rendered"></p>
      <p
        v-if="post.categories.length && post.categories[0] == 2"
        class="btn blue">
        Learn More
      </p>
      <p
        v-else
        class="btn blue">
        {{ videoSrc ? 'Watch Now' : 'Read More' }}
      </p>
    </a>
  </article>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import PostMeta from '@/components/utility/PostMeta.vue'
import PostTaxonomies from '@/components/utility/PostTaxonomies.vue'

const videoSrc = ref(false)

const props = defineProps({
  post: {
    type: Object,
    required: true,
  },
})

const formatDate = (postDate) => {
  const date = new Date(postDate)

  const dateOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }

  return new Intl.DateTimeFormat('en-US', dateOptions).format(date)
}

const urlSrc = (src) => {
  try {
    const domain = new URL(src)

    if (domain.hostname == 'www.youtube.com') {
      videoSrc.value = true
    }
  } catch (error) {
    return false
  }
}

onMounted(() => {
  if (props.post.acf.post_external) {
    urlSrc(props.post.acf.post_external)
  }
})
</script>

<style lang="scss">
.post {
  display: flex;

  a {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 60px 30px;
    background: linear-gradient(180deg, #1d78da 0%, #232e4f 100%);
    transform: scale(1);
    @include transition;

    &:hover {
      transform: scale(calc(1.025));
    }
  }

  .post-date {
    padding: 0 0 5px;
    margin: 0 0 40px;
    border-bottom: 1px solid $white;
    @include font-main;
  }

  .post-source {
    margin: 0 0 20px;
  }

  .title {
    font-size: 2.8rem;
    margin: 0 0 130px;
  }

  .btn {
    align-self: flex-end;
    margin: auto 0 0;
    z-index: 1;
  }
}
</style>
